import React from 'react'
import { Icon, Modal, Table } from 'semantic-ui-react'
import { FloodTableData } from './slice'
import { numberFormatter } from './util'

type props = {
  tableData: FloodTableData[]
}

function FloodImpactTable({ tableData }: props) {
  const renderSecondStorm = !!tableData[1]
  const generateInfoIcon = () => {
    return (
      <div>
        <Modal
          closeIcon={<Icon size={'small'} color={'black'} name={'close'}/>}
          trigger={<Icon size={'small'} color={'blue'} name={'info'} link
                         circular/>}>
          <Modal.Header>General Data Statement, {tableData[0].friendlyName} Flood
            Study, {tableData[0].publishYear}</Modal.Header>
          <Modal.Content>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="3"><i>Study Details</i></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Published Year</Table.Cell>
                  <Table.Cell>{tableData[0].publishYear}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Report Reference</Table.Cell>
                  <Table.Cell>{tableData[0].reportReference}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Flooding Type</Table.Cell>
                  <Table.Cell>{tableData[0].floodType}</Table.Cell>
                </Table.Row>
              </Table.Body>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="3"><i>Adopted Topography</i></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Topography Year</Table.Cell>
                  <Table.Cell>
                    <div dangerouslySetInnerHTML={{ __html: tableData[0].topographyYear }}/>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Modal.Content>
        </Modal>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Table singleLine collapsing={false} stackable={false} unstackable striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="left"
                              style={{ whiteSpace: 'break-spaces', width: 'fit-content', maxWidth: '50px' }}
                              collapsing>{tableData[0].friendlyName}{generateInfoIcon()}</Table.HeaderCell>
            <Table.HeaderCell colSpan="2" textAlign="center">{tableData[0].event}</Table.HeaderCell>
            {renderSecondStorm &&
                <Table.HeaderCell colSpan="2" textAlign="center">{tableData[1].event}</Table.HeaderCell>}
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell textAlign="center">Min.</Table.HeaderCell>
            <Table.HeaderCell textAlign="center">Max.</Table.HeaderCell>
            {renderSecondStorm &&
                <Table.HeaderCell textAlign="center">Min.</Table.HeaderCell>}
            {renderSecondStorm &&
                <Table.HeaderCell textAlign="center">Max.</Table.HeaderCell>}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>Water Level (m AHD)</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.heightMin != null ? numberFormatter.format(tableData[0].floodDetails.heightMin) : 'N/A'}</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.heightMax != null ? numberFormatter.format(tableData[0].floodDetails.heightMax) : 'N/A'}</Table.Cell>
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.heightMin != null ? numberFormatter.format(tableData[1].floodDetails.heightMin) : 'N/A'}</Table.Cell>}
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.heightMax != null ? numberFormatter.format(tableData[1].floodDetails.heightMax) : 'N/A'}</Table.Cell>}
          </Table.Row>
          <Table.Row>
            <Table.Cell>Water Depth (m)</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.depthMin != null ? numberFormatter.format(tableData[0].floodDetails.depthMin) : 'N/A'}</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.depthMax != null ? numberFormatter.format(tableData[0].floodDetails.depthMax) : 'N/A'}</Table.Cell>
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.depthMin != null ? numberFormatter.format(tableData[1].floodDetails.depthMin) : 'N/A'}</Table.Cell>}
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.depthMax != null ? numberFormatter.format(tableData[1].floodDetails.depthMax) : 'N/A'}</Table.Cell>}
          </Table.Row>
          <Table.Row>
            <Table.Cell>Velocity (m/s)</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.velocityMin != null ? numberFormatter.format(tableData[0].floodDetails.velocityMin) : 'N/A'}</Table.Cell>
            <Table.Cell
              textAlign="center">{tableData[0].floodDetails.velocityMax != null ? numberFormatter.format(tableData[0].floodDetails.velocityMax) : 'N/A'}</Table.Cell>
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.velocityMin != null ? numberFormatter.format(tableData[1].floodDetails.velocityMin) : 'N/A'}</Table.Cell>}
            {renderSecondStorm &&
                <Table.Cell
                    textAlign="center">{tableData[1].floodDetails.velocityMax != null ? numberFormatter.format(tableData[1].floodDetails.velocityMax) : 'N/A'}</Table.Cell>}
          </Table.Row>
        </Table.Body>
      </Table>
    </React.Fragment>
  )
}

export default FloodImpactTable